import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ArcSharedModule } from '@arc/arc-shared-frontend';
import { I18nModule } from '@arc/unified-payments-frontend/i18n';
import { QRCodeModule } from 'angularx-qrcode';
import { SharedPaymentAccountsModule } from '@arc/unified-payments-frontend/shared-payment-accounts';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { AchAuthorizationMethodComponent } from './components/ach-authorization-method/ach-authorization-method.component';
import { AddPadAgreementComponent } from './components/add-pad-agreement/add-pad-agreement.component';
import { AddPaymentMethodComponent } from './components/add-payment-method/add-payment-method.component';
import { AuthVerbiageComponent } from './components/auth-verbiage/auth-verbiage.component';
import { AutopayBadgeComponent } from './components/autopay-badge/autopay-badge.component';
import { AutopayEnrollmentBannerComponent } from './components/autopay-enrollment-banner/autopay-enrollment-banner.component';
import { SignInBannerComponent } from './components/sign-in-banner/sign-in-banner.component';
import { SignInEmailSentBannerComponent } from './components/sign-in-email-sent-banner/sign-in-email-sent-banner.component';
import { PayableAmountSectionComponent } from './components/payable-amount-section/payable-amount-section.component';
import { PayableCutoffTimeTextComponent } from './components/payable-cutoff-time-text/payable-cutoff-time-text.component';
import { PaymentAccountSelectorComponent } from './components/payment-account-selector/payment-account-selector.component';
import { PaymentDateSelectorComponent } from './components/payment-date-selector/payment-date-selector.component';
import { ReviewPaymentProcessingComponent } from './components/payment-processing/payment-processing.component';
import { PaymentReceiptRecipientsComponent } from './components/payment-receipt-recipients/payment-receipt-recipients.component';
import { PaymentSummaryHeaderComponent } from './components/payment-summary/payment-summary-header/payment-summary-header.component';
import { PaymentSummaryPrintComponent } from './components/payment-summary/payment-summary-print/payment-summary-print.component';
import { PaymentSummaryComponent } from './components/payment-summary/payment-summary.component';
import { PaymentTitleComponent } from './components/payment-title/payment-title.component';
import { PaymentTransactionsTableComponent } from './components/payment-transactions-table/payment-transactions-table.component';
import { SelectedDocumentsComponent } from './components/selected-documents/selected-documents.component';
import { SessionTimeoutComponent } from './components/session-timeout/session-timeout.component';
import { SharedDocumentTableComponent } from './components/shared-document-table/shared-document-table.component';
import { TabbedTransactionDocumentTableComponent } from './components/tabbed-transaction-document-table/tabbed-transaction-document-table.component';
import { WpxQrcodeComponent } from './components/wpx-qrcode/wpx-qrcode.component';

@NgModule({
  declarations: [
    AuthVerbiageComponent,
    PaymentDateSelectorComponent,
    PayableAmountSectionComponent,
    PayableCutoffTimeTextComponent,
    SelectedDocumentsComponent,
    SharedDocumentTableComponent,
    PaymentSummaryHeaderComponent,
    PaymentSummaryPrintComponent,
    PaymentSummaryComponent,
    PaymentTransactionsTableComponent,
    PaymentTitleComponent,
    PaymentReceiptRecipientsComponent,
    ReviewPaymentProcessingComponent,
    AutopayEnrollmentBannerComponent,
    SignInBannerComponent,
    SignInEmailSentBannerComponent,
    AutopayBadgeComponent,
    PaymentAccountSelectorComponent,
    AddPaymentMethodComponent,
    SessionTimeoutComponent,
    TabbedTransactionDocumentTableComponent,
    AchAuthorizationMethodComponent,
    AddPadAgreementComponent,
    WpxQrcodeComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ArcSharedModule,
    MultiSelectModule,
    DialogModule,
    OverlayPanelModule,
    CalendarModule,
    CheckboxModule,
    ChipsModule,
    TooltipModule,
    SelectButtonModule,
    ProgressBarModule,
    AutoCompleteModule,
    RadioButtonModule,
    TableModule,
    I18nModule,
    SharedPaymentAccountsModule,
    QRCodeModule,
  ],
  exports: [
    AuthVerbiageComponent,
    PaymentDateSelectorComponent,
    PayableAmountSectionComponent,
    PayableCutoffTimeTextComponent,
    SelectedDocumentsComponent,
    SharedDocumentTableComponent,
    PaymentSummaryHeaderComponent,
    PaymentSummaryPrintComponent,
    PaymentSummaryComponent,
    TabbedTransactionDocumentTableComponent,
    PaymentTransactionsTableComponent,
    CommonModule,
    ArcSharedModule,
    MultiSelectModule,
    DialogModule,
    OverlayPanelModule,
    CalendarModule,
    CheckboxModule,
    ChipsModule,
    TooltipModule,
    SelectButtonModule,
    ProgressBarModule,
    AutoCompleteModule,
    RadioButtonModule,
    TableModule,
    PaymentTitleComponent,
    PaymentReceiptRecipientsComponent,
    ReviewPaymentProcessingComponent,
    PaymentAccountSelectorComponent,
    AutopayEnrollmentBannerComponent,
    SignInBannerComponent,
    SignInEmailSentBannerComponent,
    AutopayBadgeComponent,
    HttpClientModule,
    AddPaymentMethodComponent,
    AchAuthorizationMethodComponent,
    AddPadAgreementComponent,
    SharedPaymentAccountsModule,
    WpxQrcodeComponent,
  ],
})
export class SharedPaymentModule {}
